import { toQueryDateYMD } from './formatters';

/** Parámetros comunes de listados paginados de venta (query string PascalCase del backend .NET). */

export interface VentaListSearchParamsBase {
  pageNumber: number;
  pageSize: number;
  searchTerm?: string;
  fechaDesde?: Date | string;
  fechaHasta?: Date | string;
  nroCliente?: string;
  nroVendedor?: string;
  nroSuc?: number;
  asentado?: string;
  estado?: string;
  usuario?: string;
}

export function buildVentaSearchQueryParams(
  params: VentaListSearchParamsBase,
): Record<string, unknown> {
  const queryParams: Record<string, unknown> = {
    PageNumber: params.pageNumber,
    PageSize: params.pageSize,
    SearchTerm: params.searchTerm || undefined,
  };

  if (params.fechaDesde) {
    queryParams.FechaDesde = toQueryDateYMD(params.fechaDesde);
  }
  if (params.fechaHasta) {
    queryParams.FechaHasta = toQueryDateYMD(params.fechaHasta);
  }
  if (params.nroCliente) queryParams.NroCliente = params.nroCliente;
  if (params.nroVendedor) queryParams.NroVendedor = params.nroVendedor;
  if (params.asentado) queryParams.Asentado = params.asentado;
  if (params.estado) queryParams.Estado = params.estado;
  if (params.usuario) queryParams.Usuario = params.usuario;
  if (params.nroSuc != null && params.nroSuc > 0) {
    queryParams.NroSuc = params.nroSuc;
  }

  return queryParams;
}

export function buildVentaKpisQueryParams(
  params: Omit<VentaListSearchParamsBase, 'pageNumber' | 'pageSize'>,
): Record<string, unknown> {
  return buildVentaSearchQueryParams({
    pageNumber: 1,
    pageSize: 1,
    ...params,
  });
}
